// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-add-a-contact{background-color:var(--background);box-shadow:0px -2px 20px rgba(45,45,45,.16);padding:0;border-radius:.375rem;z-index:10}.c-add-a-contact__space{display:block;width:100%;height:24px;box-sizing:border-box}.c-text-input__error-wrapper{padding-top:16px}.c-form__fotter-button-center{width:100%;display:flex;flex-direction:column;justify-content:center;align-items:center}", ""]);
// Exports
module.exports = exports;
